
<div class="app">
  <Base v-if="show" />
  <Modal v-if="modal.show" class="fadeIn animated">
    <Content v-if="modal.type === 'content'"></Content>
    <Rule v-if="modal.type === 'rule'"></Rule>
  </Modal>
  <Loading v-if="loading" />
</div>
